import { gql } from 'apollo-angular';

export const getCompanyList = gql`
  query GetCompanyList {
    getCompanyList {
      id
      name
      licenseId
    }
  }
`;